var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.popupBanner && _vm.visible)?_c('div',{staticClass:"topBanner"},[_c('div',{staticClass:"bg",on:{"click":_vm.close}}),_c('div',{staticClass:"body"},[_vm._t("default",null,{"banner":_vm.popupBanner}),_c('div',{staticClass:"close",on:{"click":_vm.close}})],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }